import React from 'react'

import { valueOrEmptyString } from 'helpers/strings'

import Label from './Label'
import DefaultInput from './Input'

const Input = props => <DefaultInput classNames={{ input: 'border-white' }} {...props} />

const InputOccupation = ({ autoFocus, onChange, userData }) => {
  return (
    <div className="text-white">
      <Label>Occupation</Label>
      <div className="uppercase font-medium font-ownersWide mb-2">Role</div>
      <Input
        key={autoFocus}
        autoFocus={autoFocus}
        name="occupationPosition"
        value={valueOrEmptyString(userData.profile.occupationPosition)}
        type="text"
        placeholder="Role"
        onChange={onChange}
        required
      />
      <br />
      <div className="uppercase font-medium font-ownersWide mb-2">Company</div>
      <Input
        type="text"
        name="company"
        value={valueOrEmptyString(userData.profile.company)}
        placeholder="Company"
        onChange={onChange}
        required
      />
      <br />
      <div className="uppercase font-medium font-ownersWide mb-2">Industry</div>
      <Input
        type="text"
        name="occupation"
        value={valueOrEmptyString(userData.profile.occupation)}
        placeholder="Industry"
        onChange={onChange}
        required
      />
    </div>
  )
}

export default InputOccupation
